<template>
</template>

<script>
import $ from 'jquery';
import { mapState } from 'vuex';
import { buildPtDetailItem, ensureGtmLoaded, pushEcommerceEvent } from 'assets/js/gtm';

export default {
    name: "PT508GTMAddToWishlist",
    computed: {
        ...mapState('pt110', ['pt110Init']),
        ...mapState('pt120', ['pt120Init']),
        ...mapState('pt125', ['pt125Init']),
        pt110ProductList() {
            return this.pt110Init && Array.isArray(this.pt110Init.productList) ? this.pt110Init.productList : [];
        },
        pt110NavList() {
            return this.pt110Init && Array.isArray(this.pt110Init.navList) ? this.pt110Init.navList : [];
        },
        pt120ProductInfo() {
            return this.pt120Init && this.pt120Init.productInfo ? this.pt120Init.productInfo : {};
        },
        pt120NavList() {
            return this.pt120Init && Array.isArray(this.pt120Init.navList) ? this.pt120Init.navList : [];
        },
        pt125ProductInfo() {
            return this.pt125Init && this.pt125Init.productInfo ? this.pt125Init.productInfo : {};
        },
        pt125NavList() {
            return this.pt125Init && Array.isArray(this.pt125Init.navList) ? this.pt125Init.navList : [];
        },
        gtmContainerId() {
            return this.pt110Init?.gtmcontainerId
                || this.pt120Init?.gtmcontainerId
                || this.pt125Init?.gtmcontainerId
                || '';
        },
    },
    mounted() {
        this.$nextTick(() => {
            this.initGtm(this.gtmContainerId)
            $(document).on('click', '.btn-favourite', this.listFavouriteHandler);
            $(document).on('click', '.likeBtn', this.detailFavouriteHandler);
        });
    },
    destroyed() {
        $(document).off('click', '.btn-favourite', this.listFavouriteHandler);
        $(document).off('click', '.likeBtn', this.detailFavouriteHandler);
    },
    methods: {
        hasPt110Root() {
            return !!document.querySelector('#pt110');
        },
        hasPt125Root() {
            return !!document.querySelector('#pt120 .productTop');
        },
        hasPt120Root() {
            return !!document.querySelector('#pt120') && !this.hasPt125Root();
        },
        resolveListContext() {
            if (!this.hasPt110Root()) {
                return null;
            }
            return {
                gtmContainerId: this.pt110Init && this.pt110Init.gtmcontainerId ? this.pt110Init.gtmcontainerId : '',
                navList: this.pt110NavList,
                products: this.pt110ProductList,
            };
        },
        resolveDetailContext() {
            if (this.hasPt125Root()) {
                return {
                    gtmContainerId: this.pt125Init && this.pt125Init.gtmcontainerId ? this.pt125Init.gtmcontainerId : '',
                    navList: this.pt125NavList,
                    productInfo: this.pt125ProductInfo,
                };
            }
            if (this.hasPt120Root()) {
                return {
                    gtmContainerId: this.pt120Init && this.pt120Init.gtmcontainerId ? this.pt120Init.gtmcontainerId : '',
                    navList: this.pt120NavList,
                    productInfo: this.pt120ProductInfo,
                };
            }
            return null;
        },
        initGtm(gtmContainerId) {
            if (!gtmContainerId) {
                return false;
            }
            this.$store.commit('setGtmId', gtmContainerId);
            ensureGtmLoaded();
            return true;
        },
        toNumber(value, fallback = 0) {
            const numeric = Number(value);
            return Number.isNaN(numeric) ? fallback : numeric;
        },
        resolveListPrice(product = {}) {
            const nebikiPrice = Number(product.NEBIKI_PRICE);
            if (!Number.isNaN(nebikiPrice) && nebikiPrice > 0) {
                return nebikiPrice;
            }
            const salePrice = Number(product.SALE_TNK);
            if (!Number.isNaN(salePrice)) {
                return salePrice;
            }
            return 0;
        },
        buildListItem(product = {}, navList = []) {
            const item = {
                item_id: product.S_ITEM_CD || '',
                item_name: product.WEB_ITEM_NM || '',
                price: this.resolveListPrice(product),
                quantity: 1,
                // ...(product.CATEGORY_CD1 ? { item_list_id: product.CATEGORY_CD1 } : {}),
            };

            if (navList && navList[0] && navList[0].CATEGORY_NM) {
                item.item_category = navList[0].CATEGORY_NM;
            }
            if (navList && navList[1] && navList[1].CATEGORY_NM) {
                item.item_category2 = navList[1].CATEGORY_NM;
            }
            if (navList && navList[2] && navList[2].CATEGORY_NM) {
                item.item_category3 = navList[2].CATEGORY_NM;
            }
            if (navList && navList[3] && navList[3].CATEGORY_NM) {
                item.item_category4 = navList[3].CATEGORY_NM;
            }
            if (navList && navList[4] && navList[4].CATEGORY_NM) {
                item.item_category5 = navList[4].CATEGORY_NM;
            }

            return item;
        },
        pushAddToWishlist(item) {
            if (!item || !item.item_id) {
                return;
            }
            pushEcommerceEvent('add_to_wishlist', {
                currency: 'JPY',
                value: this.toNumber(item.price, 0),
                items: [item],
            });
        },
        listFavouriteHandler(e) {
            if (e && e.__gtmWishlistHandled) {
                return;
            }
            if (e) {
                e.__gtmWishlistHandled = true;
            }
            const context = this.resolveListContext();
            if (!context || !this.initGtm(context.gtmContainerId)) {
                return;
            }

            const index = $(e.currentTarget).closest('li').index();
            if (index < 0 || index >= context.products.length) {
                return;
            }

            const product = context.products[index];
            const item = this.buildListItem(product, context.navList);
            this.pushAddToWishlist(item);
        },
        detailFavouriteHandler(e) {
            if (e && e.__gtmWishlistHandled) {
                return;
            }
            if (e) {
                e.__gtmWishlistHandled = true;
            }
            const context = this.resolveDetailContext();
            if (!context || !this.initGtm(context.gtmContainerId)) {
                return;
            }

            if (!context.productInfo || !context.productInfo.S_ITEM_NO) {
                return;
            }

            const item = Object.assign(
                {},
                buildPtDetailItem(context.productInfo, context.navList, false),
                { quantity: 1 }
            );
            this.pushAddToWishlist(item);
        },
    }
}
</script>
